export default "__VITE_ASSET__Jk8Owkga__"